 // @Author: sunyinge
 // @Email: sunyinge@pxene.com
 // @Date: 2020-03-05 10:32:04
 // @LastEditors: sunyinge
 // @LastEditTime: 2020-03-05 10:32:04
 // @Description: 防抖函数，主要用于请求列表

import Vue from "vue"

export default {
  install(Vue) {
    Vue.prototype.$delay = (function() {
      let timer = 0
      return function(callback, ms) {
        clearTimeout(timer)
        timer = setTimeout(callback, ms)
      }
    })()
  }
}
